module.exports = __webpack_public_path__ + "static/assets/20b9e4b6fa7db620799776885674803f.svg";